import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Temporal } from '@js-temporal/polyfill';
import { PointagePause } from 'src/app/domain/RH/pointage-pause';


@Component({
    selector: 'app-pointage-box',
    templateUrl: './pointage-box.html',
    styleUrls: ['./pointage-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PointageBoxDialog implements OnInit {

    public Model: PointagePause = new PointagePause();

    Debut: Date | null = null;
    Fin: Date | null = null;

    constructor(
        public dialogRef: MatDialogRef<PointageBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: PointagePause) {

        this.Model.Debut = Temporal.Now.plainDateTimeISO();
        this.Model.Fin = Temporal.Now.plainDateTimeISO();
    }

    ngOnInit() { }

    canSave() {
        return this.Debut && this.Fin && Temporal.PlainDateTime.compare(this.Model.Debut , this.Model.Fin) < 0;
    }

    timeSetDebut(event: string) {
        this.Debut = this.withTime(this.Debut, event);
        this.Model.Debut = Temporal.PlainDateTime.from({year: this.Debut.getFullYear(), day: this.Debut.getDate(), month: this.Debut.getMonth() + 1, hour: this.Debut.getHours(), minute: this.Debut.getMinutes()});
    }

    timeSetFin(event: string) {
        this.Fin = this.withTime(this.Fin, event);
        this.Model.Fin = Temporal.PlainDateTime.from({year: this.Fin.getFullYear(), day: this.Fin.getDate(), month: this.Fin.getMonth() + 1, hour: this.Fin.getHours(), minute: this.Fin.getMinutes()});
    }

    formatTime(value: Date | null): string {
        return value ? `${String(value.getHours()).padStart(2, '0')}:${String(value.getMinutes()).padStart(2, '0')}` : '';
    }

    private withTime(value: Date | null, time: string): Date {
        const [hours, minutes] = time.split(':').map(Number);
        const date = new Date(value ?? new Date());
        date.setHours(hours, minutes, 0, 0);
        return date;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.Model);
    }
}
